export default __webpack_public_path__ + "static/media/print-image.27cfc3cb.svg";